<div class="dialog-content-wrapper">
  <div class="unsave-header">
    {{ 'event.add_skills' | translate }}
  </div>
  <div class="add-skills-modal m-0" mat-dialog-content>
    @for (skill of skills; track skill) {
      <div class="skill-name">
        - {{ skill }}
      </div>
    }
    @if (showWarning) {
      <div class="warning">
        {{ 'event.some_already_skilled' | translate }}
      </div>
    }
    <div>
      <div class="users title">
        <div class="user-name">{{ 'main.frontuser' | translate }}</div>
        <div class="user-has-rewards">
        </div>
        <div class="add-logo">
          {{ 'progress' | translate }}
        </div>
      </div>
      <div class="users-table">
        @for (user of users; track user) {
          @if (user?.frontUser) {
            <div class="users">
              <div class="user-name">
                {{ user?.frontUser?.firstName }} {{ user?.frontUser?.lastName }}
              </div>
              <div class="user-has-rewards">
              </div>
              @if (!user.alreadySkilled) {
                <div class="add-logo" [ngClass]="{'green-logo' : user.newSkillAdded}">
                  <mat-icon>done_outline</mat-icon>
                </div>
              }
              @if (user.alreadySkilled) {
                <div [matTooltip]="('event.already_skilled' | translate)" class="add-logo red-logo">
                  <mat-icon>close</mat-icon>
                </div>
              }
            </div>
          }
        }
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="m-0 p-10 unsave-footer" fxLayout="row" fxLayoutAlign="end center">
    @if (!blockButton) {
      <button mat-button (click)="addSkills()">
        <span>{{ 'event.add_skills' | translate }}</span>
      </button>
    }
    @if (closeButton) {
      <button mat-button (click)="dialogRef.close()">
        <span>{{ 'close' | translate }}</span>
      </button>
    }

  </div>
</div>
